// XXX.XXX.XXX-XX
const CPF_MASK = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
// XX.XXX.XXX/XXXX-XX
const CNPJ_MASK = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
// XXXXX-XXX
const ZIP_MASK = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
// X %
const PERCENT_MASK = [/\d/, /\d/, /\d/, '%'];
// XX/XX/XXXX
const DATE_MASK = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

// (XX) XXXXX-XXXX or (XX) XXXX-XXXX
const PHONE_MASK = function(userInput) {
    let numbers = userInput.match(/\d/g);
    let numberLength = 0;
    if (numbers) {
        numberLength = numbers.join('').length;
    }
    if (numberLength > 12) {
        return ['+', '5', '5', ' ', '(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    } else {
        return ['+', '5', '5', ' ', '(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
    
};


export { CPF_MASK, CNPJ_MASK, PERCENT_MASK, PHONE_MASK, ZIP_MASK, DATE_MASK };
